<template>
  <div class="container">
    <h1 class="display-4 text-center my-5">Transaction Cancelled</h1>
    <p>
      If you're having difficulties or if you need more information, please call
      us on
      <strong class="orange-text">1800 24 68 69</strong>
    </p>
  </div>
</template>

<script>
export default {}
</script>

<style></style>
